const HamiltonData = {
  to: {
    title: "From Hamilton",
    stops: [
      {
        type: "Depart",
        name: "YHM",
      },
      {
        type: "Arrive",
        name: "YYZ",
      },
    ],
    itinerary: [
      ["5:40 AM", "6:40 AM"],
      ["11:35 AM", "12:40 PM"],
      ["2:35 PM", "3:45 PM"],
      ["5:45 PM", "6:50 PM"],
    ],
  },
  from: {
    title: "To Hamilton",
    stops: [
      {
        type: "Depart",
        name: "YYZ",
      },
      {
        type: "Arrive",
        name: "YHM",
      },
    ],
    itinerary: [
      ["8:10 AM", "9:15 AM"],
      ["1:10 PM", "2:15 PM"],
      ["4:25 PM", "5:35 PM"],
      ["9:00 PM", "10:00 PM"],
    ],
  },
}

const WaterlooData = {
  to: {
    title: "From Waterloo",
    stops: [
      {
        type: "Depart",
        name: "YKF",
      },
      {
        type: "Arrive",
        name: "YYZ",
      },
    ],
    itinerary: [
      ["5:35 AM", "6:40 AM"],
      ["9:20 AM", "10:25 AM"],
      ["11:50 AM", "12:50 PM"],
      ["2:40 PM", "3:50 PM"],
      ["5:45 PM", "6:45 PM"],
    ],
  },
  from: {
    title: "To Waterloo",
    stops: [
      {
        type: "Depart",
        name: "YYZ",
      },
      {
        type: "Arrive",
        name: "YKF",
      },
    ],
    itinerary: [
      ["8:05 AM", "9:05 AM"],
      ["10:35 AM", "11:35 AM"],
      ["1:05 APM", "2:10 PM"],
      ["4:20 PM", "5:30 PM"],
      ["8:35 PM", "9:35 PM"],
    ],
  },
}
export {
  WaterlooData,
  HamiltonData
}
